export default __webpack_public_path__ + "static/media/exalted-christian-band_exalted-christian-band-snippets-2018.2c39a24d.mp3";